const Materials = () => import('./main.vue')
const Form = () => import('./form.vue')

const meta = {
  requiresAuth: true,
}

export default [
  {
    name: 'materials.index',
    path: '/materials',
    component: Materials,
    meta,
    children: [
      {
        name: 'materials.new',
        path: 'create',
        component: Form,
        meta,
      },
      {
        name: 'materials.edit',
        path: ':id',
        component: Form,
        meta,
      },
    ],
  },
  {
    name: 'materials.new',
    path: '/materials/create',
    component: Form,
    meta,
  },
  {
    name: 'materials.edit',
    path: '/materials/:id',
    component: Form,
    meta,
  },
]
